// ─── Tree Card Helpers ──────────────────────────────────────────────

export function getCardBg(data) {
  if (!data) return '#f9fafb';
  if (data.isLiving === false) return '#f9fafb';
  if (data.gender === 'MALE') return '#eff6ff';
  if (data.gender === 'FEMALE') return '#fdf2f8';
  return '#f9fafb';
}

export function getCardBorder(data) {
  if (!data) return '#d1d5db';
  if (data.isLiving === false) return '#d1d5db';
  if (data.gender === 'MALE') return '#93c5fd';
  if (data.gender === 'FEMALE') return '#f9a8d4';
  return '#d1d5db';
}

export function getAvatarBg(data) {
  if (!data) return '#e5e7eb';
  if (data.isLiving === false) return '#e5e7eb';
  if (data.gender === 'MALE') return '#dbeafe';
  if (data.gender === 'FEMALE') return '#fce7f3';
  return '#e5e7eb';
}

export function getAvatarTextColor(data) {
  if (!data) return '#6b7280';
  if (data.isLiving === false) return '#6b7280';
  if (data.gender === 'MALE') return '#1e40af';
  if (data.gender === 'FEMALE') return '#9d174d';
  return '#6b7280';
}

export function getInitials(name) {
  if (!name) return '?';
  return name.split(' ').map(n => n[0]).join('').slice(0, 2);
}

// ─── Build a lookup map of person ID → { person, pedigreeData } ──
// This lets us reconstruct the nav stack from URL params on refresh
export function buildPersonLookup(pedigreeData, lookup = new Map()) {
  if (!pedigreeData) return lookup;
  const { root, rootSiblings = [], parentGeneration, grandparentGeneration } = pedigreeData;
  const { father, mother, fatherSiblings = [], motherSiblings = [] } = parentGeneration || {};

  const allPersons = [
    root,
    ...(rootSiblings || []),
    father, mother,
    ...(fatherSiblings || []),
    ...(motherSiblings || []),
    grandparentGeneration?.paternalGrandfather,
    grandparentGeneration?.paternalGrandmother,
    grandparentGeneration?.maternalGrandfather,
    grandparentGeneration?.maternalGrandmother,
  ].filter(Boolean);

  // Also include spouses from sibling arrays
  const spouses = [...(fatherSiblings || []), ...(motherSiblings || [])]
    .map(s => s.spouse).filter(Boolean);

  for (const p of [...allPersons, ...spouses]) {
    if (p && p.id) {
      lookup.set(p.id, { person: p, pedigreeData });
      // Recurse into family data
      if (p.family) buildPersonLookup(p.family, lookup);
    }
  }
  return lookup;
}